import React from "react";
import type { ImageProps } from "../image";
import { Image } from "../image";

export const Img = (props: Omit<ImageProps, "alt">) => (
  <Image {...props} alt="logo" />
);
